var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiechart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8787 15.8783V0C7.37362 0.446115 0.446603 7.37308 0.000488281 15.8783H15.8787ZM12.3633 13.2416H10.6055V11.4839H12.3633V13.2416ZM7.09004 7.96842H8.84778V9.72616H7.09004V7.96842ZM11.4844 7.60451L12.7272 8.84729L7.96891 13.6056L6.72613 12.3628L11.4844 7.60451Z",
    fill: "#FF82AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8787 17.636H5.36572C5.79403 23.2371 10.2776 27.7207 15.8787 28.149V17.636H15.8787Z",
    fill: "#FF82AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6362 3.5155C17.6362 3.70428 17.6362 30.2063 17.6362 29.9988C24.4956 29.5432 29.999 23.6423 29.999 16.6694C29.999 9.6959 24.4973 3.96953 17.6362 3.5155ZM22.9095 15.8783C24.3633 15.8783 25.5461 17.061 25.5461 18.5149C25.5461 19.6592 24.8091 20.6256 23.7883 20.9896V22.9092H22.0306V20.9896C21.0098 20.6256 20.2728 19.6592 20.2728 18.5149H22.0306C22.0306 18.9998 22.4246 19.3938 22.9095 19.3938C23.3944 19.3938 23.7883 18.9998 23.7883 18.5149C23.7883 18.03 23.3944 17.636 22.9095 17.636C21.4556 17.636 20.2728 16.4533 20.2728 14.9994C20.2728 13.8551 21.0098 12.8887 22.0306 12.5247V10.6051H23.7883V12.5247C24.8091 12.8887 25.5461 13.8551 25.5461 14.9994H23.7883C23.7883 14.5145 23.3944 14.1205 22.9095 14.1205C22.4246 14.1205 22.0306 14.5145 22.0306 14.9994C22.0306 15.4843 22.4246 15.8783 22.9095 15.8783Z",
    fill: "#FF82AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiechart);
export default __webpack_public_path__ + "static/media/piechart.003307c290105935ba45c450cdc1e1e3.svg";
export { ForwardRef as ReactComponent };